import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { colorText } from "../App/theme.js";

export function CircularLoaderWithText({ isOpen, message }) {
    if (!isOpen) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                zIndex: 1000
            }}
        >
            <Box sx={{maxWidth: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <CircularProgress />
                <Typography variant="h6" mt={2} color={colorText}>
                    {message}
                </Typography>
            </Box>
        </Box>
    );
}
